@if (loading()) {
  <iot-platform-ui-card-loader data-cy="iot-platform-ui-list-view-content-loader" fxFlex fxFlexAlign="center"
                               [backgroundClass]="'mv-detail-card h-140'" />
} @else {
  <iot-platform-ui-overview-card [loading]="loading()" [overviewCard]="card()"
                                 data-cy="iot-platform-ui-list-view-content-card"
                                 (cardButtonClicked)="onDispatchCardEvent($event)" />
}

